/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Defaults_DescriptionInputs */



/**
* | output |
* | --- |
* | "What a new agent starts with when its creator does not choose otherwise. Existing agents are not changed." |
*
* @param {Agent_Policy_Defaults_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_defaults_description = /** @type {((inputs?: Agent_Policy_Defaults_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Defaults_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Womit ein neuer Agent startet, wenn die erstellende Person nichts anderes wählt. Bestehende Agenten werden nicht geändert.")
	return /** @type {LocalizedString} */ ("What a new agent starts with when its creator does not choose otherwise. Existing agents are not changed.")
});